const ALLOWED_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
const LENGTH = 24;

const generateTransactionId = () => {
  const chars = new Array(LENGTH);
  for (let i = 0; i < LENGTH; i++) {
    chars[i] = ALLOWED_CHARS[Math.floor(Math.random() * ALLOWED_CHARS.length)];
  }
  return chars.join('');
};

const transactionId = generateTransactionId();

export const getTransactionId = () => transactionId;
